module.exports = __webpack_public_path__ + "img/logo.508764a1.png";